// AUTO-GENERATED. Do not edit. Regenerated by scripts/generate-build-info.js.
// Runs on prestart/prebuild — see package.json scripts.
export const BUILD_VERSION = "2.1.139";
export const GIT_COMMIT_SHORT = "56b8eb28";
export const BUILD_TIMESTAMP = "2026-11-04T16:39:32.709Z";
